export const UPDATE_OPZIONE_CONTRATTUALE    = 'UPDATE_OPZIONE_CONTRATTUALE';
export const CHECK_LIFE_CYCLE_M122P03       = 'CHECK_LIFE_CYCLE_M122P03';
